import {lazy} from '@aboutyou/lazy-imports';
import {FooterSkeleton} from '@aboutyou/logic-components';
import React from 'react';

const FooterStaticCacheable = lazy(
  () =>
    import('./FooterStatic.eager').then(module => ({
      default: module.FooterStaticCacheable,
    })),
  {fallback: <FooterSkeleton />},
);

export const FooterStatic = () => <FooterStaticCacheable />;
